import { useVisibleAxesConfig } from './useVisibleAxesConfig.js';
import { useVisibleAxesScales } from './useVisibleAxesScales.js';

export function useVisibleXAxisByPriority() {
  const axesScale = useVisibleAxesScales();
  const axesConfig = useVisibleAxesConfig();

  return {
    axisType: axesConfig.bottom?.type ?? axesConfig.top?.type,
    axisScale: axesScale.bottom ?? axesScale.top,
  };
}
